import { toastr } from "react-redux-toastr";
import api from "../Service/Api";
import { controller } from "../Constants/api";

export const getAllActivityByUserIdApi = async id => {
    if (navigator.onLine === false) {
      toastr.error('No Internet Connection', 'Please try again');
    } else {
      try {
        const response = await api.get(`${controller.activity}/get-all-user-activity/${id}`);
  
        if (typeof response !== 'undefined') {
          if (response.status === 200) {
            // toastr.success('Fetched all activities successfully')
            return response.data;
          }
        } else {
          toastr.error('An error occured', 'Please try again')
        }
      } catch (err) {
        // toastr.error(err.response.data.message)
      }
    }
  }
  